const modal = document.querySelector(".modal");
const backdrop = document.querySelector(".modal__backdrop");

function showModal(modal) {
    // Display block on modal
    modal.style.display = "block";
    // Add modal-open to body
    document.body.classList.add("modal-open");
    // remove fade and add show to backdrop
    backdrop.classList.add("show");
    backdrop.classList.remove("fade");
}

function hideModal(modal) {
    // Display block on modal
    modal.style.display = "none";
    // Add modal-open to body
    document.body.classList.remove("modal-open");
    // remove fade and add show to backdrop
    backdrop.classList.remove("show");
    backdrop.classList.add("fade");
}

document.querySelectorAll('[data-toggle="modal"]').forEach(button => {
    button.addEventListener("click", function (e) {
        if (! this.hasAttribute("data-submit")) e.preventDefault(); // Stop form submitting if button is inside a form
        showModal(modal);
    });
});

document.querySelectorAll('[data-dismiss="modal"]').forEach(close => {
    close.addEventListener("click", function () {
        hideModal(modal);
    });
});
